<div>
  <footer class="o-footer -minimal">
    @if (sideNavigationService.isSideNavOpen()) {
      <hr class="a-divider" />
      <div class="e-container">
        <div
          [ngClass]="{
            'o-footer__bottom_sideNavClosed': !sideNavigationService.isSideNavOpen(),
          }"
          class="o-footer__bottom flex !flex-col-reverse gap-4 transition-opacity duration-150 ease-out"
        >
          <ul class="o-footer__links">
            <li>
              <div class="a-link a-link--integrated">
                <a
                  href="https://bgn.bosch.com/FIRSTspiritWeb/permlink/wcms_corpfunc_-transparency_1-EN"
                  target="_blank"
                >
                  <span>Data Protection Policy</span>
                </a>
              </div>
            </li>
            <li>
              <div class="a-link a-link--integrated">
              <release-version-link></release-version-link>
              </div>
            </li>
          </ul>
          <div class="o-footer__copyright">
            <i class="a-icon boschicon-bosch-ic-copyright-frame"></i>
            {{ year }} Robert Bosch GmbH, all rights reserved
          </div>
        </div>
      </div>
    } @else {
      <div class="flex flex-col text-center mb-2">
        <release-version-link></release-version-link>

        <i
          [ngClass]="{
            'a-icon-big': !sideNavigationService.isSideNavOpen(),
          }"
          class="a-icon boschicon-bosch-ic-copyright-frame p-3"
        ></i>
      </div>
    }
  </footer>
</div>
